<template>
  <!-- 弹窗-查询积分即将过期的会员 -->
  <y-dialog
    title="查询积分即将到期的会员"
    :visible="isShowDialog"
    width="800px"
    :before-close="cancelBtn"
    :is-show-sure="false"
    :is-show-cancel="false"
    @close="cancelBtn"
  >
    <y-tip style="margin: 0 0 20px 0">
      <!-- <div>提示</div> -->
      <div>
        1.
        可在当前界面查询积分即将到期的会员，保存为静态人群。每个静态人群中限制最多1000,000条数据。创建成功的人群，可在客户分群列表中查看。
      </div>
      <div>
        2.可在当前界面设置查询条件，并导出即将到期的会员和即将到期积分。每天限制导出100,000条数据。
      </div>
      <div>3.请注意，查询时会包含会员黑名单中的会员和退会状态会员。</div>
    </y-tip>
    <el-form ref="form" :model="form" label-width="110px" size="small">
      <el-form-item required label="即将过期时间：">
        <el-radio-group v-model="form.expireTimeType">
          <el-radio label="nextWeek">下周</el-radio>
          <el-radio label="nextMonth">下个月</el-radio>
          <el-radio label="yearEnd">本年年底</el-radio>
          <el-radio label="before">指定时间以前</el-radio>
          <el-radio label="range">指定时间期间</el-radio>
        </el-radio-group>
        <!-- 指定时间以前 / 指定时间期间 才需要选具体日期 -->
        <div class="date-row" v-if="isDateType">
          <el-date-picker
            v-if="form.expireTimeType === 'before'"
            v-model="form.expireDate"
            type="datetime"
            placeholder="选择时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px"
          ></el-date-picker>
          <el-date-picker
            v-else
            v-model="form.expireDateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="起始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 400px"
          ></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item required label="即将过期积分：">
        <div class="displayItem">
          <el-select
            v-model="form.compareType"
            style="width: 120px; margin-right: 8px"
          >
            <el-option
              v-for="item in compareTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            v-model="form.scoreValue"
            placeholder="请输入 0 ~ 99999 之间的值"
            style="width: 200px"
            clearable
            v-numOnly9
          ></el-input>
          <span style="margin: 0 8px" v-if="form.compareType == 5">-</span>
          <el-input
            v-if="form.compareType == 5"
            v-model="form.scoreValue2"
            placeholder="请输入 0 ~ 99999 之间的值"
            style="width: 200px"
            clearable
            v-numOnly9
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label-width="110px">
        <el-button
          type="primary"
          size="small"
          @click="queryBtn"
          :loading="queryLoading"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 查询结果 -->
    <div class="query-result" v-if="queryResult">
      <div class="result-bar">
        <span class="result-text">
          查询结果：共查找
          <span class="num">{{ queryResult.total }}</span>
          个会员，即将过期积分总计
          <span class="num">{{ queryResult.pointTotal }}</span>
        </span>
        <div class="result-actions">
          <el-button type="text" @click="exportBtn">导出</el-button>
          <el-button type="text" @click="saveGroupBtn">保存人群</el-button>
        </div>
      </div>
      <div class="preview-title">预览（最多可查看 10 条记录）</div>
      <y-table
        :tableInfo="queryInfo"
        :showPage="false"
        :tableData="queryResult.list"
        :loading="queryLoading"
      >
      </y-table>
    </div>

    <!-- 生成人群包 -->
    <crowdDialog
      v-if="showCrowdDialog"
      :isShowDialog="showCrowdDialog"
      :loading="saveLoading"
      @comfirm="sureSaveCrowd"
      @close="showCrowdDialog = false"
    ></crowdDialog>
    <!-- 添加备注 -->
    <addRemarks
      v-if="exportDialog"
      :control="exportDialog"
      :exportForm="exportForm"
      :exportUrl="exportUrlData"
      exportKey="exportRemark"
      @transData="transData">
    </addRemarks>
  </y-dialog>
</template>

<script>
import {
  getRunningTask,
  queryExpirePointMembers,
  getQueryResult,
  saveCrowd,
} from "@/api/memberMessageSystem";
import crowdDialog from "./crowdDialog.vue";
import addRemarks from "@/components/add-remarks.vue";
export default {
  components: {
    crowdDialog,
    addRemarks,
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        expireTimeType: "yearEnd", // 即将过期时间：下周/下个月/本年底/指定时间以前/指定时间期间
        expireDate: "", // 指定时间以前
        expireDateRange: [], // 日期区间
        compareType: 1, // 积分比较方式
        scoreValue: "", // 积分值
        scoreValue2: "", // 积分值2
      },
      compareTypeList: [
        { label: "大于", value: 1 },
        { label: "大于等于", value: 2 },
        { label: "小于", value: 3 },
        { label: "小于等于", value: 4 },
        { label: "介于（含边界）", value: 5 },
        { label: "等于", value: 6 },
      ],
      queryInfo: [
        {
          label: "全渠道会员ID",
          prop: "memberId",
        },
        {
          label: "即将到期积分",
          prop: "expireScores",
        },
      ],
      queryLoading: false,
      // 查询结果：{ total 会员数, pointTotal 积分总计, list 预览列表 }
      queryResult: null,
      taskId: "", // 异步查询任务id
      pollTimer: null, // 轮询定时器
      pollCount: 0, // 已轮询次数（防止无限轮询）
      showCrowdDialog: false, // 生成人群包弹窗
      saveLoading: false,
      exportDialog: false, // 导出弹窗
      exportUrlData: "/expire/Scores/export",
      exportForm: {},
    };
  },
  watch: {
    isShowDialog(val) {
      if (val) {
        // 打开弹窗先看有没有运行中的任务，有就直接轮询结果
        this.checkRunningTask();
      } else {
        this.stopPolling();
      }
    },
  },
  mounted() {
    // 父组件用 v-if 控制本组件，打开时 isShowDialog 一开始就是 true，
    // watch 不会触发，需要在这里初次检查一次运行中的任务
    if (this.isShowDialog) {
      this.checkRunningTask();
    }
  },
  beforeDestroy() {
    this.stopPolling();
  },
  computed: {
    // 只有「指定时间以前 / 指定时间期间」需要选具体日期
    isDateType() {
      return ["before", "range"].indexOf(this.form.expireTimeType) > -1;
    },
  },
  created() {
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo || {};
  },
  methods: {
    // 查询
    queryBtn() {
      const {
        expireTimeType,
        expireDate,
        expireDateRange,
        scoreValue,
        scoreValue2,
      } = this.form;
      if (expireTimeType === "before" && !expireDate) {
        return this.$message.warning("请选择指定时间");
      }
      if (
        expireTimeType === "range" &&
        (!expireDateRange || expireDateRange.length !== 2)
      ) {
        return this.$message.warning("请选择指定时间期间");
      }
      if (
        scoreValue === "" ||
        scoreValue === null ||
        scoreValue === undefined ||
        isNaN(Number(scoreValue))
      ) {
        return this.$message.warning("请输入即将过期积分");
      }
      this.fetchQueryResult();
    },
    // 格式化日期：isEnd 为 true 取当天 23:59:59，否则取 00:00:00
    formatDateTime(date, isEnd) {
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      const y = date.getFullYear();
      const m = pad(date.getMonth() + 1);
      const d = pad(date.getDate());
      return `${y}-${m}-${d} ${isEnd ? "23:59:59" : "00:00:00"}`;
    },
    // 即将过期时间区间 → expiryStartTime / expiryEndTime
    // type 不传时取当前表单的选择，回显时可按指定类型试算
    getExpiryTimeRange(type = this.form.expireTimeType) {
      const now = new Date();
      if (type === "nextWeek") {
        // 下周：下周一 00:00:00 ~ 下周日 23:59:59
        // getDay(): 周日是 0，统一成周一=1 … 周日=7
        const weekDay = now.getDay() === 0 ? 7 : now.getDay();
        const monday = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - (weekDay - 1) + 7
        );
        const sunday = new Date(
          monday.getFullYear(),
          monday.getMonth(),
          monday.getDate() + 6
        );
        return {
          expiryStartTime: this.formatDateTime(monday, false),
          expiryEndTime: this.formatDateTime(sunday, true),
        };
      }
      if (type === "nextMonth") {
        // 下个月：下月 1 号 00:00:00 ~ 下月最后一天 23:59:59
        const firstDay = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        // 下下个月的第 0 天 = 下个月最后一天
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 2, 0);
        return {
          expiryStartTime: this.formatDateTime(firstDay, false),
          expiryEndTime: this.formatDateTime(lastDay, true),
        };
      }
      if (type === "yearEnd") {
        // 本年年底：只传结束时间（本年 12-31 23:59:59）
        return {
          expiryStartTime: "",
          expiryEndTime: `${now.getFullYear()}-12-31 23:59:59`,
        };
      }
      if (type === "before") {
        // 指定时间以前：只传结束时间
        return {
          expiryStartTime: "",
          expiryEndTime: this.form.expireDate || "",
        };
      }
      // 指定时间期间：起止都传
      const [start, end] = this.form.expireDateRange || [];
      return {
        expiryStartTime: start || "",
        expiryEndTime: end || "",
      };
    },
    // 组装查询参数
    getQueryParams() {
      const { compareType, scoreValue, scoreValue2 } = this.form;
      const { expiryStartTime, expiryEndTime } = this.getExpiryTimeRange();
      return {
        expiryStartTime,
        expiryEndTime,
        compareType,
        scoreValue: Number(scoreValue),
        // 第二区间仅「介于」时传
        scoreValue2:
          compareType === 5 && scoreValue2 !== ""
            ? Number(scoreValue2)
            : undefined,
      };
    },
    // 接口返回的 data 可能是 taskId 字符串，也可能是 { taskId } 对象
    pickTaskId(res) {
      const data = res && res.data;
      if (!data) return "";
      if (typeof data === "object") return data.taskId || "";
      return data;
    },
    // 打开弹窗：判断是否有运行中的查询任务
    checkRunningTask() {
      console.log("checkRunningTask");
      this.queryResult = null;
      getRunningTask().then((res) => {
        const taskId = this.pickTaskId(res);
        if (taskId) {
          // 有运行中的任务：直接轮询结果
          this.startPolling(taskId);
        }
      });
    },
    // 开始轮询任务结果
    startPolling(taskId) {
      if (!taskId) return;
      this.stopPolling();
      this.taskId = taskId;
      this.pollCount = 0;
      this.queryLoading = true;
      this.pollTaskResult();
      this.pollTimer = setInterval(() => {
        this.pollTaskResult();
      }, 2000);
    },
    // 单次查询任务结果
    pollTaskResult() {
      // 最多轮询 5 分钟（150 次 * 2 秒），避免任务卡死时一直请求
      if (this.pollCount >= 150) {
        this.stopPolling();
        this.$message.error("查询超时，请稍后重试");
        return;
      }
      this.pollCount += 1;
      getQueryResult({ taskId: this.taskId }).then((res) => {
        const data = res && res.data;
        if (!data) return;
        // 回显提交时的查询条件（刷新后凭 taskId 恢复条件）
        if (data.queryCond) {
          this.echoQueryCond(data.queryCond);
        }
        // status：0 运行中、1 成功、2 失败
        const status = Number(data.status);
        if (status === 1) {
          this.stopPolling();
          this.queryResult = {
            total: data.memberTotal || 0,
            pointTotal: data.scoresTotal || 0,
            list: data.memberList || [],
          };
        } else if (status === 2) {
          this.stopPolling();
          this.$message.error(data.errMsg || "查询失败");
        }
      });
    },
    // 停止轮询
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      this.queryLoading = false;
    },
    // 回显查询条件（接口任务详情返回的 queryCond）
    echoQueryCond(cond) {
      if (!cond) return;
      const {
        expiryStartTime,
        expiryEndTime,
        compareType,
        scoreValue,
        scoreValue2,
      } = cond;
      // 即将过期积分条件
      if (compareType) {
        this.form.compareType = Number(compareType);
      }
      this.form.scoreValue =
        scoreValue === null || scoreValue === undefined
          ? ""
          : String(scoreValue);
      this.form.scoreValue2 =
        scoreValue2 === null || scoreValue2 === undefined
          ? ""
          : String(scoreValue2);
      // 即将过期时间条件
      if (expiryStartTime && expiryEndTime) {
        // 有起止时间：先匹配「下周」「下个月」这两个相对区间，对不上按「指定时间期间」回显
        const nextWeek = this.getExpiryTimeRange("nextWeek");
        const nextMonth = this.getExpiryTimeRange("nextMonth");
        if (
          expiryStartTime === nextWeek.expiryStartTime &&
          expiryEndTime === nextWeek.expiryEndTime
        ) {
          this.form.expireTimeType = "nextWeek";
        } else if (
          expiryStartTime === nextMonth.expiryStartTime &&
          expiryEndTime === nextMonth.expiryEndTime
        ) {
          this.form.expireTimeType = "nextMonth";
        } else {
          this.form.expireTimeType = "range";
          this.form.expireDateRange = [expiryStartTime, expiryEndTime];
        }
      } else if (expiryEndTime) {
        // 只有结束时间：本年年底 或 指定时间以前
        const yearEnd = this.getExpiryTimeRange("yearEnd").expiryEndTime;
        if (expiryEndTime === yearEnd) {
          this.form.expireTimeType = "yearEnd";
        } else {
          this.form.expireTimeType = "before";
          this.form.expireDate = expiryEndTime;
        }
      }
    },
    // 查询：发起异步任务，拿到 taskId 后轮询结果
    fetchQueryResult() {
      const params = this.getQueryParams();
      this.queryResult = null;
      this.queryLoading = true;
      queryExpirePointMembers(params)
        .then((res) => {
          if (res.code == 200) {
            const taskId = res.data;
            if (taskId) {
              this.startPolling(taskId);
            } else {
              this.queryLoading = false;
              this.$message.error((res && res.message) || "查询失败");
            }
          }
        })
        .catch(() => {
          this.queryLoading = false;
        });
    },
    // 导出
    exportBtn() {
      this.exportForm = this.getQueryParams();
      this.exportDialog = true;
    },
    // 保存人群：打开生成人群包弹窗
    saveGroupBtn() {
      this.showCrowdDialog = true;
    },
    // 生成人群包确定
    sureSaveCrowd({ crowdName, crowdDescription }) {
      this.saveLoading = true;
      saveCrowd({
        ...this.getQueryParams(),
        crowdName,
        crowdDescription,
      })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.showCrowdDialog = false;
            this.$emit("saveGroup", this.getQueryParams());
          } else {
            this.$message.error((res && res.message) || "保存失败");
          }
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    // 取消弹窗
    cancelBtn() {
      this.$emit("close");
    },
    transData(val) {
      this.exportDialog = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.displayItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.date-row {
  margin-top: 12px;
  line-height: 1;
}
.query-result {
  margin-top: 8px;
  .result-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #ebeef5;
    font-size: 14px;
    color: #333333;
    .num {
      font-weight: 600;
    }
  }
  .result-actions {
    display: flex;
    align-items: center;
  }
  .preview-title {
    margin: 12px 0;
    font-size: 13px;
    color: #666666;
  }
}
</style>
